export default __webpack_public_path__ + "static/media/your-path.958b5c2c.svg";